export const CLOUDINARY_ASSETS = {
  home: {
    hero_image: "lv5xe1hext0vcm80gujn",
  },
  team: {
    sabrina: "gj0szn8vdv9fmwjvsit5",
    denis: "b6shzfxty6vuyiwrpr2i",
  },
};
